import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export async function submitLead(type, payload) {
    const { data } = await api.post(`/leads/${type}`, payload);
    return data;
}

export async function fetchOpenings() {
    const { data } = await api.get("/careers/openings");
    return data;
}

export const RESUME_MAX_BYTES = 5 * 1024 * 1024; // 5 MB
export const RESUME_ALLOWED_EXT = ["pdf", "doc", "docx"];

export async function uploadResume(file, onProgress) {
    const form = new FormData();
    form.append("file", file);
    const { data } = await api.post("/upload/resume", form, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (e) => {
            if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
        },
    });
    return data;
}
